import React from 'react';
import { Link } from 'react-router-dom';
import { FMessage } from '../../hoc/IntlComponents';

const FlowWarning = () => (
  <div className="flow-recommendation-warning">
    <h6 className="flow-recommendation-warning-title">
      <FMessage id="flow.form.recommendation.warning.title" />
    </h6>
    <p className="flow-recommendation-warning-text">
      <FMessage id="flow.form.recommendation.warning.p1" />
    </p>
    <p className="flow-recommendation-warning-text">
      <FMessage
        id="flow.form.recommendation.warning.p2"
        values={{
          link1: (
            <Link to="/tools/domains/add">
              <FMessage id="flow.form.recommendation.warning.link" />
            </Link>
          ),
          link2: <Link to="/tools/api">API</Link>,
        }}
      />
    </p>
  </div>
);

export default FlowWarning;
